import {
  blueSecondary,
  grayBorder,
  blue
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import {
  fontSize16,
  gridGutterHalf
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const luggageCardStyle = `
  display: flex;
  flex-wrap: wrap;

  .blue {
    color: ${blue};
  }

  .luggage-header {
    color: ${blueSecondary};
    font-size: ${fontSize16};
    text-transform: uppercase;
    padding: ${gridGutterHalf}px 0;
    border-bottom: solid 1px ${grayBorder};
  }

  .luggage-item {
    padding: ${gridGutterHalf}px;
    min-width: 50%;
    @media (max-width: 1024px) {
      min-width: 100%;
    }
  }

  .padding-gutter-half {
    padding: ${gridGutterHalf}px 0;
  }

  .block {
    display: block;
  }

  .icon {
    padding-right: 10px;
  }
`